import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Accordion, AccordionDetails, AccordionSummary } from 'base-ui'

import {
  ProductPrescriptionDrawer,
  useProductPrescriptionDrawerControls,
} from '../ProductPrescriptionDrawer'

import { ProductPrescriptionTypeSelect } from './ProductPrescriptionTypeSelect'

export const ProductPrescriptionTypeCollapsible: FC = () => {
  const prescriptionDrawerControls = useProductPrescriptionDrawerControls()

  return (
    <Accordion className="mb-5 tablet:mt-10">
      <AccordionSummary
        className="text-m font-bold text-dark-primary-max"
        data-qa-id="product-prescription-type-collapsible"
      >
        <FormattedMessage id="product.prescription.prescriptionAvailable" />
      </AccordionSummary>
      <AccordionDetails>
        <ProductPrescriptionTypeSelect className="w-full" />
        <button
          className="mt-3.5 font-bold text-dark-brand hover:underline"
          onClick={(): void => {
            prescriptionDrawerControls.handleOpen()
          }}
          type="button"
        >
          <FormattedMessage id="product.prescription.howItWorks" />
        </button>
        <ProductPrescriptionDrawer controls={prescriptionDrawerControls} />
      </AccordionDetails>
    </Accordion>
  )
}
